import { useAtomValue } from "jotai";
import type { MouseEvent } from "react";
import { canv } from "@/canv/global";
import { ArrowIcon } from "@/icons/widget-menu";
import { widgetMenuAvailableOptions } from "@/interface/AppStore";
import { HStack } from "@/shared/ui/Stack";
import type { MenuOptionResult, SetActiveSubMenu } from "../../types";
import styles from "../../WidgetMenu.module.css";

interface UseFilterButtonProps {
    setActiveSubMenu: SetActiveSubMenu;
}

export function useFilterButton({ setActiveSubMenu }: UseFilterButtonProps): MenuOptionResult {
    useAtomValue(widgetMenuAvailableOptions);

    const content = (
        <HStack className={styles.text} gap={6}>
            Объектов: {canv.canvasController.selected.length}{" "}
            <ArrowIcon style={{ transform: "rotate(180deg)" }} />
        </HStack>
    );

    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        const button = event.currentTarget;

        setActiveSubMenu((prev) =>
            prev?.name === "filter" ? null : { name: "filter", anchor: button },
        );
    };

    return {
        content,
        handleClick,
    };
}
